//SettingsDialog
//***********************************************************************************************************************
import * as React from "react";
import * as tokenService from "../../models/services/tokenService";
import * as appService from "../../models/services/appService";
import { SaveDataObj } from "../../framework/saveData";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../framework/dialog";
import { AppUtils } from "../../framework/appUtils";
import { ConfirmationDialogResult, DialogButtonType } from "ui/Scripts/source/models/enums";
import { IUserState } from "../../models/store/storeTypes";
import { ISettingsEdit } from "../../models/settings/settingsEdit";

//SettingsDialog
export interface ISettingsDialogProps {
    classes?: string;
    userState: IUserState;
    settingsEdit: ISettingsEdit;
    onOk: () => void;
    onCancel: () => void;
}

export interface ISettingsDialogState {
    theme: string;
    culture: string;
}

export class SettingsDialog extends React.Component<ISettingsDialogProps, ISettingsDialogState> {
    private static orgStateHash = "";

    constructor(props: ISettingsDialogProps) {
        super(props);
        this.state = {
            theme: props.settingsEdit.settings.theme,
            culture: props.settingsEdit.settings.culture
        };
        SettingsDialog.orgStateHash = SettingsDialog.getSaveDataFromState(props, this.state).hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "theme") {
            this.setState({ theme: value });
        } else if (name === "culture") {
            this.setState({ culture: value });
        }
    };

    private static getSaveDataFromState = (props: ISettingsDialogProps, state: ISettingsDialogState): SaveDataObj => {
        const data = new SaveDataObj();
        data.append("theme", state.theme);
        data.append("culture", state.culture);
        return data;
    };

    checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            return resolve(true);
        });
    };

    getWarningMessage = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            return resolve("");
        });
    };

    saveSettings = async () => {
        if (!await AppUtils.validate(this.checkErrors, this.getWarningMessage)) return;
        const saveData = SettingsDialog.getSaveDataFromState(this.props, this.state);
        //Call server
        const result = await AppUtils.callService(() => appService.saveSettings(saveData.obj));
        if (!result) return;
        await AppUtils.callService(() => tokenService.refreshAuthentication(true));
        this.props.onOk();
        location.reload();
    };

    handleCancelClick = async () => {
        const props = this.props;
        const cancelResult = await AppUtils.cancel(SettingsDialog.getSaveDataFromState(this.props, this.state).hash, SettingsDialog.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveSettings();
        } else {
            props.onCancel();
        }
    };

    handleOkClick = () => {
        this.saveSettings();
    };

    render() {
        const props = this.props;
        const state = this.state;
        const dialogClasses = "settingsDialog" + (props.classes ? " " + props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={Translations.Settings}
                body={
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="control-label">{Translations.Theme}</label>
                                    <select className="form-control" name="theme" title={Translations.Theme} value={state.theme} onChange={this.handleChange}>
                                        <option key="default" value="">{Translations.DefaultStyle}</option>
                                        {props.settingsEdit.themes.map(theme =>
                                            <option key={theme.id} value={theme.id}>{theme.title}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="control-label">{Translations.Language}</label>
                                    <select className="form-control" name="culture" title={Translations.Language} value={state.culture} onChange={this.handleChange}>
                                        {props.settingsEdit.cultures.map(culture =>
                                            <option key={culture.id} value={culture.id}>{culture.title}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                buttons={[{ title: Translations.Save, buttonType: DialogButtonType.Primary, onClick: this.handleOkClick }, { title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick }]}
                onClose={this.handleCancelClick}/>
        );
    }
}